import { z } from 'zod';

/**
 * Схемы запросов аутентификации — общие для API, витрины и админки.
 * Бизнес-правила (политика паролей, блокировки) проверяются на сервере в @shop/core.
 */

const email = z.email().max(254);
const password = z.string().min(1).max(128);
const token = z.string().min(20).max(128);
const locale = z.enum(['lv', 'lt', 'et', 'ru', 'en']);

export const registerCustomerSchema = z.object({
  email,
  password,
  locale,
  marketCode: z.string().max(16).optional(),
  firstName: z.string().trim().max(100).optional(),
  lastName: z.string().trim().max(100).optional(),
});
export type RegisterCustomerRequest = z.infer<typeof registerCustomerSchema>;

export const loginSchema = z.object({ email, password });
export type LoginRequest = z.infer<typeof loginSchema>;

export const emailOnlySchema = z.object({ email });
export const tokenSchema = z.object({ token });

export const resetPasswordSchema = z.object({ token, password });
export type ResetPasswordRequest = z.infer<typeof resetPasswordSchema>;

/** 6 цифр из приложения или резервный код вида xxxxxxxx-xxxxxxxx. */
export const mfaCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^(\d{6}|[0-9a-fA-F]{8}-[0-9a-fA-F]{8})$/, 'Enter the 6-digit code or a recovery code'),
});

export const reauthSchema = z.object({
  password,
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Enter the 6-digit code'),
});

export const createStaffSchema = z.object({
  email,
  displayName: z.string().trim().min(1).max(100),
  roles: z.array(z.string().min(1).max(64)).min(1).max(10),
});
export type CreateStaffRequest = z.infer<typeof createStaffSchema>;
